import { initDb, getZooId } from "../tools/conf"
import { getAnimalsQueryScope } from "../utils/firestore/animalsZooScope"
import _ from "lodash"
import moment from "moment"
import { obsDataConnector } from "./obsDataConnector"
import { OBS_MAIN_CATEGORIES } from "../components/Views/ObsManagement/ObsManagementView/obsSetup"
import { getColorFromCategory, getFadeColorFromCategory } from "../tools/style/colors"
import { QUESTIONS_SUBCATEGORY_1, QUESTIONS_SUBCATEGORY_2, QUESTIONS_SUBCATEGORY_3, QUESTIONS_SUBCATEGORY_4 } from "../components/Views/Quizz/QuestionManagementView/tools/confQuestions"

const db = initDb()

export class welfareAnalyser {
  async _getAllCampaignEval(campaignId) {
    let quizzTable = []
    let snapshot = await db.collection("quizz").where("campaignId", "==", campaignId).get()
    if (snapshot.empty) {
    } else {
      snapshot.forEach((doc) => {
        quizzTable.push(doc.data())
      })
    }
    return quizzTable
  }

  async _getAllCampaignObsEval(campaignId) {
    let quizzTable = []
    let snapshot = await db.collection("obs").where("campaignId", "==", campaignId).get()
    if (snapshot.empty) {
    } else {
      snapshot.forEach((doc) => {
        quizzTable.push(doc.data())
      })
    }
    return quizzTable
  }

  async _getAllAnimalEval(animalId, start, stop, filterTraining, filterPedago) {
    try {
      let snapshot
      if (start === undefined && stop === undefined) {
        let quizzTable = []
        if (filterTraining) {
          if (filterPedago) {
            snapshot = await db.collection("quizz").where("animalId", "==", animalId).where("isPedago", "==", false).where("isValid", "==", true).get()
          } else {
            snapshot = await db.collection("quizz").where("animalId", "==", animalId).where("isPedago", "==", true).where("isValid", "==", true).get()
          }
        } else {
          if (filterPedago) {
            snapshot = await db.collection("quizz").where("animalId", "==", animalId).where("isPedago", "==", false).get()
          } else {
            snapshot = await db.collection("quizz").where("animalId", "==", animalId).where("isPedago", "==", true).get()
          }
        }

        if (snapshot.empty) {
        } else {
          snapshot.forEach((doc) => {
            quizzTable.push(doc.data())
          })
        }
        return quizzTable
      }

      let quizzTable = []

      if (filterTraining) {
        if (filterPedago) {
          snapshot = await db.collection("quizz").where("animalId", "==", animalId).where("quizzStop", ">", start).where("quizzStop", "<", stop).where("isPedago", "==", false).where("isValid", "==", true).get()
        } else {
          snapshot = await db.collection("quizz").where("animalId", "==", animalId).where("quizzStop", ">", start).where("quizzStop", "<", stop).where("isPedago", "==", true).where("isValid", "==", true).get()
        }
      } else {
        if (filterPedago) {
          snapshot = await db.collection("quizz").where("animalId", "==", animalId).where("quizzStop", ">", start).where("quizzStop", "<", stop).where("isPedago", "==", false).get()
        } else {
          snapshot = await db.collection("quizz").where("animalId", "==", animalId).where("quizzStop", ">", start).where("quizzStop", "<", stop).where("isPedago", "==", true).get()
        }
      }

      if (snapshot.empty) {
      } else {
        snapshot.forEach((doc) => {
          quizzTable.push(doc.data())
        })
      }
      return quizzTable
    } catch (error) {
      console.log(error)
      return []
    }
  }

  getMaxBehaviorCounter(ethogramme) {
    let maxCounter = {}
    let counter = 0
    for (let keys in ethogramme.categoriesOptions) {
      ethogramme.categoriesOptions[keys].map((behavior) => {
        counter++
        maxCounter = {
          ...maxCounter,
          total: counter,
          [behavior.categoryId]: maxCounter[behavior.categoryId] === undefined ? 1 : maxCounter[behavior.categoryId] + 1,
        }
      })
    }
    return maxCounter
  }

  getBehaviorPeriodAverage(obsPeriod, maxCounter) {
    let periodCounter = {
      total: 0,
      totalBehavior: 0,
      n: obsPeriod.length,
    }

    OBS_MAIN_CATEGORIES.map((el) => {
      periodCounter = {
        ...periodCounter,
        [el.categoryId]: {
          sum: 0,
          average: 0,
        },
      }
    })

    let periodSpotted = []

    obsPeriod.map((obs) => {
      obs.obsData.map((behavior) => {
        let i = periodSpotted.indexOf(behavior.optionId)
        if (i < 0) {
          periodSpotted.push(behavior.optionId)
          periodCounter = {
            ...periodCounter,
            total: periodCounter.total + 1,
            [behavior.categoryId]: {
              ...periodCounter[behavior.categoryId],
              sum: periodCounter[behavior.categoryId].sum === undefined ? 1 : periodCounter[behavior.categoryId].sum + 1,
            },
          }
        }
      })
    })

    let bigAverage = Math.round((periodCounter.total / maxCounter.total) * 100)

    OBS_MAIN_CATEGORIES.map((el) => {
      let average = Math.round((periodCounter[el.categoryId].sum / maxCounter[el.categoryId]) * 100)
      if (el !== "total") {
        periodCounter = {
          ...periodCounter,
          average: bigAverage,
          [el.categoryId]: {
            ...periodCounter[el.categoryId],
            average: average,
          },
        }
      }
    })
    return periodCounter
  }

  async _getBehaviorVariation(periodEnd, type, obsTable) {
    try {
      let table = []
      let i

      let obsConnect = new obsDataConnector()
      let obsData = await obsConnect._getObsFromId(obsTable[0].obsId, true)

      let maxBehaviorCounter = this.getMaxBehaviorCounter(obsData)

      for (i = 0; i < 12; i++) {
        let periodObs = {
          obs: [],
          data: null,
          label: null,
        }
        let activeMoment = moment(periodEnd).subtract(i, type)
        obsTable.map((obs) => {
          if (moment.unix(obs.obsStop).isSame(activeMoment, type)) {
            periodObs.obs.push(obs)
          }
        })

        periodObs.data = this.getBehaviorPeriodAverage(periodObs.obs, maxBehaviorCounter)

        if (type === "months") {
          periodObs.stringMoment = `${activeMoment.format("MM-YY")} n${periodObs.obs.length}`
        } else if (type === "weeks") {
          periodObs.stringMoment = activeMoment.format("MM-YY")
        } else if (type === "days") {
          periodObs.stringMoment = activeMoment.format("DD-MM")
        }
        table.push(periodObs)
      }
      return table.reverse()
    } catch (error) {
      return []
    }
  }

  async _getGroupAnimalEval(animalIds) {
    let quizz = {}
    await Promise.all(
      animalIds.map(async (animalId) => {
        let snapshot = await db.collection("quizz").where("animalId", "==", animalId).get()
        if (snapshot.empty) {
        } else {
          snapshot.forEach((doc) => {
            let data = doc.data()
            console.log(data)

            quizz = {
              ...quizz,
              [data.syncId]: {
                ...data,
              },
            }
          })
        }
      })
    )

    let quizzTable = []

    for (let key in quizz) {
      quizzTable.push(quizz[key])
    }
    return quizzTable
  }

  async _getAllAnimalObs(animalId) {
    let quizzTable = []

    if (Array.isArray(animalId)) {
      await Promise.all(
        animalId.map(async (id) => {
          let snapshot = await db.collection("obs").where("animalId", "==", id).get()
          if (snapshot.empty) {
          } else {
            snapshot.forEach((doc) => {
              quizzTable.push(doc.data())
            })
          }
        })
      )
    } else {
      let snapshot = await db.collection("obs").where("animalId", "==", animalId).get()
      if (snapshot.empty) {
      } else {
        snapshot.forEach((doc) => {
          quizzTable.push(doc.data())
        })
      }
    }
    return quizzTable
  }

  _getQuizzAverage(quizzData) {
    let quizzIndex = 0
    let enclosureScore = 0
    let foodScore = 0
    let healthScore = 0
    let behaviorScore = 0
    let indiceScore = 0

    quizzData.map((quizz) => {
      enclosureScore = enclosureScore + quizz.enclosureScore
      foodScore = foodScore + quizz.foodScore
      healthScore = healthScore + quizz.healthScore
      behaviorScore = behaviorScore + quizz.behaviorScore
      indiceScore = indiceScore + quizz.indiceScore
      quizzIndex = quizzIndex + 1
    })

    return {
      enclosureAverage: isNaN(Math.ceil(enclosureScore / quizzIndex)) ? null : Math.ceil(enclosureScore / quizzIndex),
      foodAverage: isNaN(Math.ceil(foodScore / quizzIndex)) ? null : Math.ceil(foodScore / quizzIndex),
      healthAverage: isNaN(Math.ceil(healthScore / quizzIndex)) ? null : Math.ceil(healthScore / quizzIndex),
      behaviorAverage: isNaN(Math.ceil(behaviorScore / quizzIndex)) ? null : Math.ceil(behaviorScore / quizzIndex),
      indiceAverage: isNaN(Math.ceil(indiceScore / quizzIndex)) ? null : Math.ceil(indiceScore / quizzIndex),
    }
  }

  _getFakeLastTwelveAverage(periodEnd, type, quizzTable) {
    let table = []
    let i
    for (i = 0; i < 12; i++) {
      let periodQuizz = {
        quizz: [],
        average: null,
      }
      let activeMoment = moment(periodEnd).subtract(i, type)
      quizzTable.map((quizz) => {
        if (moment.unix(quizz.quizzStop).isSame(activeMoment, type)) {
          periodQuizz.quizz.push(quizz)
        }
      })
      periodQuizz.average = 12
      if (type === "months") {
        periodQuizz.stringMoment = activeMoment.format("MM-YY")
      } else if (type === "weeks") {
        periodQuizz.stringMoment = activeMoment.format("MM-YY")
      } else if (type === "days") {
        periodQuizz.stringMoment = activeMoment.format("DD-MM")
      }

      table.push(periodQuizz)
    }
    return table.reverse()
  }

  _getLastTwelveAverage(periodEnd, type, quizzTable) {
    let table = []
    let i
    let lastAverage = null
    for (i = 0; i < 12; i++) {
      let periodQuizz = {
        quizz: [],
        average: null,
      }
      let activeMoment = moment(periodEnd).subtract(i, type)
      quizzTable.map((quizz) => {
        if (moment.unix(quizz.quizzStop).isSame(activeMoment, type)) {
          periodQuizz.quizz.push(quizz)
        }
      })

      periodQuizz.average = this._getQuizzAverage(periodQuizz.quizz)

      if (type === "months") {
        periodQuizz.stringMoment = activeMoment.format("MM-YY")
      } else if (type === "weeks") {
        periodQuizz.stringMoment = `S${activeMoment.week()}`
      } else if (type === "days") {
        periodQuizz.stringMoment = activeMoment.format("DD-MM")
      }

      table.push(periodQuizz)
    }
    return table.reverse()
  }

  _getLastTwelveQuizzAlert(periodEnd, type, quizzTable) {
    let table = []
    let i
    for (i = 0; i < 12; i++) {
      let periodCounter = 0
      let activeMoment = moment(periodEnd).subtract(i, type)
      quizzTable.map((quizz) => {
        if (moment.unix(quizz.quizzStop).isSame(activeMoment, type)) {
          periodCounter = periodCounter + quizz.alertAmount
        }
      })
      table.push(periodCounter)
    }
    return table.reverse()
  }

  _getLastTwelveQuizzAmount(periodEnd, type, quizzTable) {
    let table = []
    let i
    for (i = 0; i < 12; i++) {
      let periodCounter = 0
      let activeMoment = moment(periodEnd).subtract(i, type)

      console.log(activeMoment.format("DD/MM/YYYY"))

      quizzTable.map((quizz) => {
        if (moment.unix(quizz.quizzStop).isSame(activeMoment, type)) {
          periodCounter++
        }
      })
      table.push(periodCounter)
    }
    return table.reverse()
  }

  _getLastTwelveObsAmount(periodEnd, type, obsTable) {
    let table = []
    let i
    for (i = 0; i < 12; i++) {
      let periodCounter = 0
      let activeMoment = moment(periodEnd).subtract(i, type)
      obsTable.map((obs) => {
        if (moment.unix(obs.obsStop).isSame(activeMoment, type)) {
          periodCounter++
        }
      })
      table.push(periodCounter)
    }
    return table.reverse()
  }

  _getLabelBarGraph(animalActiveViewData) {
    let barGraphLabel = []
    animalActiveViewData.map((el) => {
      barGraphLabel.push(el.stringMoment)
    })
    return barGraphLabel
  }

  getTrendsFromMesure(mesure) {
    let trends = []
    let interval = 0
    let last = 0
    let isMesuredArray = []
    mesure.forEach((el) => {
      if (el === null) {
        interval = interval + 1
        isMesuredArray.push(false)
      } else {
        for (let index = 0; index <= interval; index++) {
          trends.push(el)
        }
        isMesuredArray.push(true)
        interval = 0
        last = el
      }
    })

    if (interval > 0) {
      for (let index = 0; index <= interval; index++) {
        trends.push(last)
      }
    }

    return {
      isMesuredArray: isMesuredArray,
      data: trends,
    }
  }

  _getBarGraphData(animalActiveViewData) {
    try {
      console.log("init")

      let behaviorBarGraph = []
      let foodBarGraph = []
      let enclosureBarGraph = []
      let healthBarGraph = []
      let indiceBarGraph = []

      animalActiveViewData.map((el) => {
        behaviorBarGraph.push(el.average.behaviorAverage)
        foodBarGraph.push(el.average.foodAverage)
        healthBarGraph.push(el.average.healthAverage)
        enclosureBarGraph.push(el.average.enclosureAverage)
        indiceBarGraph.push(el.average.indiceAverage)
      })

      let mesureArray = this.getTrendsFromMesure(behaviorBarGraph).isMesuredArray
      let behaviorBarGraphTrend = this.getTrendsFromMesure(behaviorBarGraph).data
      let foodBarGraphTrend = this.getTrendsFromMesure(foodBarGraph).data
      let enclosureBarGraphTrend = this.getTrendsFromMesure(enclosureBarGraph).data
      let healthBarGraphTrend = this.getTrendsFromMesure(healthBarGraph).data
      let indiceBarGraphTrend = this.getTrendsFromMesure(indiceBarGraph).data

      let barGraphData = {
        behaviorAverage: behaviorBarGraph,
        foodAverage: foodBarGraph,
        healthAverage: healthBarGraph,
        enclosureAverage: enclosureBarGraph,
        indiceAverage: indiceBarGraph,
      }

      let barGraphDataTrend = {
        behaviorAverage: behaviorBarGraphTrend,
        foodAverage: foodBarGraphTrend,
        healthAverage: healthBarGraphTrend,
        enclosureAverage: enclosureBarGraphTrend,
        indiceAverage: indiceBarGraphTrend,
      }

      return {
        animalBarGraph: barGraphDataTrend,
        mesureArray: mesureArray,
      }
    } catch (error) {
      console.log(error)
    }
  }

  async _getWellfareOverviewFromQuizz(quizzData, survey) {
    let questionsSum = this.getCategoryQuestionLength(quizzData.quizzQuestions)
    let maxScore = this.getMaxScores(quizzData.quizzQuestions)
    return {
      categoryQuestionAmount: questionsSum,
      categoryMaxScore: maxScore,
    }
  }

  getCategoryQuestionLength(answers) {
    let cat1 = 0
    let cat2 = 0
    let cat3 = 0
    let cat4 = 0

    answers.map((answer) => {
      if (answer.category === 1) {
        ++cat1
      } else if (answer.category === 2) {
        ++cat2
      } else if (answer.category === 3) {
        ++cat3
      } else if (answer.category === 4) {
        ++cat4
      }
    })

    let res = {
      surveyQuestionsSum: answers.length,
      cat1QuestionSum: cat1,
      cat2QuestionSum: cat2,
      cat3QuestionSum: cat3,
      cat4QuestionSum: cat4,
    }
    return res
  }

  getMaxScores(answers) {
    let cat1 = 0
    let cat2 = 0
    let cat3 = 0
    let cat4 = 0
    answers.map((answer) => {
      if (answer.category === 1) {
        cat1 = cat1 + this.getQuestionMaxScore(answer.questionOptions)
      } else if (answer.category === 2) {
        cat2 = cat2 + this.getQuestionMaxScore(answer.questionOptions)
      } else if (answer.category === 3) {
        cat3 = cat3 + this.getQuestionMaxScore(answer.questionOptions)
      } else if (answer.category === 4) {
        cat4 = cat4 + this.getQuestionMaxScore(answer.questionOptions)
      }
    })

    return {
      cat1MaxScore: cat1,
      cat2MaxScore: cat2,
      cat3MaxScore: cat3,
      cat4MaxScore: cat4,
      maxScore: cat1 + cat2 + cat3 + cat3,
    }
  }

  getQuestionMaxScore(options) {
    let maxPoints = 0
    options.map((option) => {
      parseInt(option.optionPoints)
      if (parseInt(option.optionPoints) >= maxPoints) {
        maxPoints = parseInt(option.optionPoints)
      }
    })
    return maxPoints
  }

  async _getAnimalWelfareStats(data) {
    let analytics = []
    let quizzTable = []
    let snapshot = await db.collection("quizz").where("animalId", "==", data.animalId).get()
    if (snapshot.empty) {
    } else {
      snapshot.forEach((doc) => {
        quizzTable.push(doc.data())
      })
    }

    await Promise.all(
      quizzTable.map(async (quizz) => {
        let res = await this._getBasedScores(quizz)
        analytics.push(res)
      })
    )

    return {
      wellfareStats: analytics,
      quizzTable: quizzTable,
    }
  }

  async _getWelfareStats(quizzTable) {
    let analytics = []
    for (let quizz in quizzTable) {
      let res = await this._getBasedScores(quizzTable[quizz])
      analytics.push(res)
    }
    return analytics
  }

  async _getBasedScores(quizzData) {
    let surveyData = await (await db.collection("survey").doc(quizzData.surveyId).get()).data()

    let results = this.getScores(quizzData.answers)
    let wellfareStats = this.getMarks(results, surveyData.categoryMaxScore, 100)
    wellfareStats.quizzDay = quizzData.creationEnd
    return wellfareStats
  }

  getScores(answers) {
    let cat1 = 0
    let cat2 = 0
    let cat3 = 0
    let cat4 = 0

    answers.map((answer) => {
      if (answer.questionCategory === 1) {
        cat1 = cat1 + this.getQuestionScore(answer.answers)
      } else if (answer.questionCategory === 2) {
        cat2 = cat2 + this.getQuestionScore(answer.answers)
      } else if (answer.questionCategory === 3) {
        cat3 = cat3 + this.getQuestionScore(answer.answers)
      } else if (answer.questionCategory === 4) {
        cat4 = cat4 + this.getQuestionScore(answer.answers)
      }
    })

    return {
      cat1Score: cat1,
      cat2Score: cat2,
      cat3Score: cat3,
      cat4Score: cat4,
      quizzScore: cat1 + cat2 + cat3 + cat4,
    }
  }

  getQuestionScore(anwsers) {
    let questionScore = 0
    anwsers.map((anwser) => {
      questionScore = questionScore + parseInt(anwser.optionPoints)
    })
    return questionScore
  }

  getMarks(done, max, base) {
    let markCat1 = Math.round(((done.cat1Score / max.cat1MaxScore) * base + Number.EPSILON) * 1) / 1
    let markCat2 = Math.round(((done.cat2Score / max.cat2MaxScore) * base + Number.EPSILON) * 1) / 1
    let markCat3 = Math.round(((done.cat3Score / max.cat3MaxScore) * base + Number.EPSILON) * 1) / 1
    let markCat4 = Math.round(((done.cat4Score / max.cat4MaxScore) * base + Number.EPSILON) * 1) / 1
    let surveyMark = Math.round(((done.quizzScore / max.maxScore) * base + Number.EPSILON) * 1) / 1

    return {
      markCat1: markCat1,
      markCat2: markCat2,
      markCat3: markCat3,
      markCat4: markCat4,
      surveyMark: surveyMark,
    }
  }

  async _getBasedScoresFromAnimalId(zooId, animalData) {
    let db = initDb()
    let snapshot = await db.collection("quizz").where("animalId", "==", animalData.animalId).get()
    let animalQuizz = []
    snapshot.forEach((doc) => {
      animalQuizz.push(doc.data())
    })

    if (animalQuizz.length > 0) {
      let wellfareTable = []
      await Promise.all(
        animalQuizz.map(async (quizzData) => {
          let results = this.getScores(quizzData.answers)
          let surveyData = await (await db.collection("survey").doc(quizzData.surveyId).get()).data()
          let wellfareStats = this.getMarks(results, surveyData.categoryMaxScore, 100)
          wellfareStats.quizzDay = quizzData.creationEnd
          wellfareTable.push(wellfareStats)
        })
      )
      return {
        animalId: animalData.animalId,
        wellfareTable: wellfareTable,
      }
    } else {
      return {
        animalId: animalData.animalId,
        wellfareTable: null,
      }
    }
  }

  _getGroupBarGraph(activeMoment, groupWellfareStats, activeCategory, offset) {
    let offsetMoment = moment(activeMoment)
    offsetMoment.subtract(offset, "month").endOf("month")

    let activeGroupBarGraph = []
    for (let i = 0; i < 12; i++) {
      let tempMoment = moment(offsetMoment).endOf("month")
      tempMoment.subtract(i, "month")
      let newEntry = this._getGroupWellfareOverviewForActivePeriode(groupWellfareStats, "montly", tempMoment)
      if (newEntry !== null) {
        switch (activeCategory) {
          case 1:
            activeGroupBarGraph.push(newEntry.markCat1)
            break
          case 2:
            activeGroupBarGraph.push(newEntry.markCat2)
            break
          case 3:
            activeGroupBarGraph.push(newEntry.markCat3)
            break
          case 4:
            activeGroupBarGraph.push(newEntry.markCat4)
            break
          case null:
            activeGroupBarGraph.push(newEntry.surveyMark)
            break
          default:
            break
        }
      } else {
        activeGroupBarGraph.push(null)
      }
    }
    return activeGroupBarGraph.reverse()
  }

  async _getGroupWellfareOverview(groupId) {
    const zooId = await getZooId()
    let animalArray = await this.getAnimalArray(groupId)
    let groupWellfareOverview = []
    await Promise.all(
      animalArray.map(async (animalData) => {
        let res = await this._getBasedScoresFromAnimalId(zooId, animalData)
        groupWellfareOverview.push(res)
      })
    )
    return groupWellfareOverview
  }

  async getAnimalArray(groupId) {
    let animalArray = []
    const { zooId } = await getAnimalsQueryScope()
    let snapshot = await db.collection("animals").where("zooId", "==", zooId).where("animalGroupId", "==", groupId).where("isArchived", "!=", true).get()

    snapshot.forEach((doc) => {
      animalArray.push(doc.data())
    })

    return animalArray
  }

  async getAnimaldata(zooId, animalId) {
    let snapshot = await db.collection("animals").doc(animalId).get()
    return snapshot.data()
  }

  _getActiveMomentWellfareStat(wellfareStats, requiredMoment, selectedOffset) {
    let offsetMoment = moment(requiredMoment)
    offsetMoment.subtract(selectedOffset, "month").endOf("month")

    let activeFoundQuizz = {
      markCat1: 0,
      markCat2: 0,
      markCat3: 0,
      markCat4: 0,
      surveyMark: 0,
      evaluated: false,
    }

    wellfareStats.map((item) => {
      let momentQuizzData = moment.unix(item.creationEnd).endOf("month")

      if (momentQuizzData.isSame(offsetMoment, "month")) {
        activeFoundQuizz = item
        activeFoundQuizz.evaluated = true
      } else {
      }
    })

    return activeFoundQuizz
  }

  _getGroupWellfareOverviewForActivePeriode(groupWellfareOverview, quizzType, requiredMoment, selectedOffset) {
    quizzType = "monthly"
    let globalQuizz = []

    let offsetMoment = moment(requiredMoment)
    offsetMoment.subtract(selectedOffset, "month").endOf("month")

    groupWellfareOverview.map((animalQuizzTable) => {
      if (animalQuizzTable.wellfareTable !== null) {
        animalQuizzTable.wellfareTable.map((quizz) => {
          let momentEval = moment.unix(quizz.quizzDay).endOf("month")
          let isSameMonth = offsetMoment.isSame(momentEval, "month")
          if (isSameMonth) {
            globalQuizz.push(quizz)
          }
        })
      }
    })
    let res = this.getAverageMarkFromGroup(globalQuizz, offsetMoment)
    return res
  }

  _getPeriodeAverageMark(activePeriodGroupQuizzGrades, activeMoment, step) {
    if (activePeriodGroupQuizzGrades.length > 0) {
      let sumCat1 = 0
      let sumCat2 = 0
      let sumCat3 = 0
      let sumCat4 = 0
      let sumSurvey = 0

      let activePeriodCounter = 0

      activePeriodGroupQuizzGrades.map((marks) => {
        let quizzMoment = moment.unix(marks.quizzDay).endOf(step.slice(0, -1))
        if (quizzMoment.isSame(activeMoment, step.slice(0, -1))) {
          activePeriodCounter = activePeriodCounter + 1
          sumCat1 = sumCat1 + marks.markCat1
          sumCat2 = sumCat2 + marks.markCat2
          sumCat3 = sumCat3 + marks.markCat3
          sumCat4 = sumCat4 + marks.markCat4
          sumSurvey = sumSurvey + marks.surveyMark
        }
      })
      return {
        markCat1: Math.ceil(sumCat1 / activePeriodCounter),
        markCat2: Math.ceil(sumCat2 / activePeriodCounter),
        markCat3: Math.ceil(sumCat3 / activePeriodCounter),
        markCat4: Math.ceil(sumCat4 / activePeriodCounter),
        surveyMark: Math.ceil(sumSurvey / activePeriodCounter),
        period: activeMoment.format("LLLL"),
      }
    } else {
      return {
        markCat1: 0,
        markCat2: 0,
        markCat3: 0,
        markCat4: 0,
        surveyMark: 0,
        period: activeMoment.format("LLLL"),
      }
    }
  }

  getAverageMarkFromGroup(activePeriodGroupQuizzGrades, moment) {
    if (activePeriodGroupQuizzGrades.length > 0) {
      let sumCat1 = 0
      let sumCat2 = 0
      let sumCat3 = 0
      let sumCat4 = 0
      let sumSurvey = 0

      activePeriodGroupQuizzGrades.map((marks) => {
        sumCat1 = sumCat1 + marks.markCat1
        sumCat2 = sumCat2 + marks.markCat2
        sumCat3 = sumCat3 + marks.markCat3
        sumCat4 = sumCat4 + marks.markCat4
        sumSurvey = sumSurvey + marks.surveyMark
      })
      return {
        markCat1: Math.ceil(sumCat1 / activePeriodGroupQuizzGrades.length),
        markCat2: Math.ceil(sumCat2 / activePeriodGroupQuizzGrades.length),
        markCat3: Math.ceil(sumCat3 / activePeriodGroupQuizzGrades.length),
        markCat4: Math.ceil(sumCat4 / activePeriodGroupQuizzGrades.length),
        surveyMark: Math.ceil(sumSurvey / activePeriodGroupQuizzGrades.length),
        period: moment.format("LLL"),
      }
    } else {
      return null
    }
  }

  _getBarStats(wellfareStats, category, startMoment, offset) {
    let offsetMoment = moment(startMoment)
    offsetMoment.subtract(offset, "month").endOf("month")

    let labelArray = this.getDynamicLabel(offsetMoment)
    let barData = this.populateHystory(wellfareStats, category, offsetMoment)
    return {
      barData: barData,
      label: labelArray,
    }
  }

  getDynamicLabel(requiredMoment) {
    let requiredMomentString = requiredMoment.format("LLL")
    let labelArray = []
    for (let index = 0; index < 12; index++) {
      labelArray.push(moment(requiredMomentString).locale("fr").subtract(index, "months").format("MMM"))
    }
    return labelArray.reverse()
  }

  populateHystory(wellfareStats, category, startMoment) {
    let populatedData = []
    for (let index = 0; index < 12; index++) {
      let activeMoment = moment(startMoment).subtract(index, "months").endOf("month")
      let periodEval = 0
      let activeQuizz
      let periodQuizzTable = []

      wellfareStats.map((quizzResult) => {
        activeQuizz = { ...quizzResult }
        let momentQuizz = moment.unix(quizzResult.quizzDay).endOf("month")
        if (momentQuizz.isSame(activeMoment)) {
          periodEval = periodEval + 1
          periodQuizzTable.push(activeQuizz)
        }
      })

      if (periodEval === 0) {
        populatedData.push(null)
      } else {
        let marks = 0
        switch (category) {
          case 1:
            periodQuizzTable.map((quizz) => {
              marks = marks + quizz.markCat1
            })
            break
          case 2:
            periodQuizzTable.map((quizz) => {
              marks = marks + quizz.markCat2
            })
            break
          case 3:
            periodQuizzTable.map((quizz) => {
              marks = marks + quizz.markCat3
            })
            break
          case 4:
            periodQuizzTable.map((quizz) => {
              marks = marks + quizz.markCat4
            })
            break
          default:
            periodQuizzTable.map((quizz) => {
              marks = marks + quizz.surveyMark
            })
            break
        }
        populatedData.push(Math.trunc(marks / periodQuizzTable.length))
      }
    }
    return populatedData.reverse()
  }

  populateGroupHystory(groupWellfareStats, quizzType, requiredMoment, category) {
    let activeGroupWellfareStats = []

    for (let index = 0; index < 12; index++) {
      let activeMoment = moment().subtract(index, "months")
      let data = this._getGroupWellfareOverviewForActivePeriode(groupWellfareStats, "monthly", activeMoment)
      if (data !== null) {
        switch (category) {
          case 1:
            activeGroupWellfareStats.push(data.markCat1)
            break
          case 2:
            activeGroupWellfareStats.push(data.markCat2)
            break
          case 3:
            activeGroupWellfareStats.push(data.markCat2)
            break
          case 4:
            activeGroupWellfareStats.push(data.markCat4)
            break
          default:
            activeGroupWellfareStats.push(data.surveyMark)
            break
        }
      } else {
        activeGroupWellfareStats.push(data)
      }
    }

    return activeGroupWellfareStats.reverse()
  }

  _getQuizzMark(quizz) {
    let score = this.getScores(quizz.answers)
    let marks = this.getMarks(score, quizz.survey.categoryMaxScore, 100)
    return marks
  }

  _getQuizzDetails(lastEvalDetails, type) {
    let polarArray = []
    let polarLabel = []
    let polarColor = []
    let polarData = []
    let arrayCategory = []

    let sortedList = lastEvalDetails.sort((a, b) => a.quizzStop - b.quizzStop)
    let quizz

    if (type === "last") {
      sortedList.reverse()
      quizz = sortedList[0]
    } else {
      sortedList.reverse()
      quizz = sortedList[0]
    }

    QUESTIONS_SUBCATEGORY_1.forEach((el) => {
      if (el.value !== null) {
        try {
          polarArray.push({
            catId: el.value,
            polarLabel: el.label,
            polarData: quizz.details.enclosureSubScore[`cat${el.value}`].categoryScore === 0 ? 2 : quizz.details.enclosureSubScore[`cat${el.value}`].categoryScore,
            polarColor: type === "last" ? getColorFromCategory(1) : getFadeColorFromCategory(1),
          })
        } catch (error) {
          console.log(error)
        }
      }
    })

    console.log("polarArray")
    console.log(polarArray)

    let sorted = polarArray.sort((a, b) => a.polarData - b.polarData)
    sorted.reverse()

    sorted.map((el) => {
      arrayCategory.push(el.catId)
      polarColor.push(el.polarColor)
      polarData.push(el.polarData)
      polarLabel.push(el.polarLabel)
    })

    polarArray = []

    QUESTIONS_SUBCATEGORY_2.forEach((el) => {
      if (el.value !== null) {
        try {
          polarArray.push({
            catId: el.value,
            polarLabel: el.label,
            polarData: quizz.details.foodSubScore[`cat${el.value}`].categoryScore,
            polarColor: type === "last" ? getColorFromCategory(2) : getFadeColorFromCategory(2),
          })
        } catch (error) {}
      }
    })

    sorted = polarArray.sort((a, b) => a.polarData - b.polarData)
    sorted.reverse()

    sorted.map((el) => {
      arrayCategory.push(el.catId)
      polarColor.push(el.polarColor)
      polarData.push(el.polarData)
      polarLabel.push(el.polarLabel)
    })

    polarArray = []

    QUESTIONS_SUBCATEGORY_3.forEach((el) => {
      if (el.value !== null) {
        try {
          polarArray.push({
            catId: el.value,
            polarLabel: el.label,
            polarData: quizz.details.healthSubScore[`cat${el.value}`].categoryScore,
            polarColor: type === "last" ? getColorFromCategory(3) : getFadeColorFromCategory(3),
          })
        } catch (error) {}
      }
    })

    sorted = polarArray.sort((a, b) => a.polarData - b.polarData)
    sorted.reverse()
    sorted.map((el) => {
      arrayCategory.push(el.catId)
      polarColor.push(el.polarColor)
      polarData.push(el.polarData)
      polarLabel.push(el.polarLabel)
    })

    polarArray = []

    QUESTIONS_SUBCATEGORY_4.forEach((el) => {
      if (el.value !== null) {
        try {
          polarArray.push({
            catId: el.value,
            polarLabel: el.label,
            polarData: quizz.details.behaviorSubScore[`cat${el.value}`].categoryScore,
            polarColor: type === "last" ? getColorFromCategory(4) : getFadeColorFromCategory(4),
          })
        } catch (error) {}
      }
    })

    sorted = polarArray.sort((a, b) => a.polarData - b.polarData)
    sorted.reverse()
    sorted.map((el) => {
      arrayCategory.push(el.catId)
      polarColor.push(el.polarColor)
      polarData.push(el.polarData)
      polarLabel.push(el.polarLabel)
    })

    let dateString = moment.unix(quizz.quizzStop).format("DD/MM/YYYY")

    return {
      arrayCategory: arrayCategory,
      polarColor: polarColor,
      polarData: polarData,
      polarLabel: polarLabel,
      dateString: dateString,
      date: quizz.quizzStop,
    }
  }

  _getLastEvalAverage = (animalsQuizz, type) => {
    let averageDiverderTable = new Array(22).fill(0)
    let averageTableMaxScore = new Array(22).fill(0)
    let polarColor
    let arrayCategory

    let maxDate = 0
    let minDate = 0

    for (let animal in animalsQuizz) {
      let quizz = animalsQuizz[animal]
      if (quizz !== null) {
        let lastEvalDetails = this._getQuizzDetails(animalsQuizz[animal], type)
        polarColor = lastEvalDetails.polarColor
        arrayCategory = lastEvalDetails.arrayCategory
        lastEvalDetails.polarData.map((el, index) => {
          if (!isNaN(el)) {
            averageDiverderTable[index] = averageDiverderTable[index] + 1 || 1
            averageTableMaxScore[index] = averageTableMaxScore[index] + el || el
          }
        })
        if (lastEvalDetails.date > maxDate) {
          maxDate = lastEvalDetails.date
        }
        if (minDate === 0) {
          minDate = lastEvalDetails.date
        }
        if (lastEvalDetails.date < minDate) {
          minDate = lastEvalDetails.date
        }
      }
    }

    let averageScore = []

    averageTableMaxScore.map((el, index) => {
      if (el > 0) {
        let value = Math.round(el / averageDiverderTable[index])
        averageScore.push(value)
      } else {
        averageScore.push(el)
      }
    })

    const max = Math.max(...averageDiverderTable)
    const maxValueIndex = averageDiverderTable.indexOf(max)
    const maxValue = averageDiverderTable[maxValueIndex]

    let dateString = `[${moment.unix(minDate).format("DD/MM/YYYY")} - ${moment.unix(maxDate).format("DD/MM/YYYY")}] (${maxValue})`

    return {
      polarColor: polarColor,
      polarData: averageScore,
      polarLabel: "string",
      dateString: dateString,
      arrayCategory: arrayCategory,
    }
  }
}
